import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';

export function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-white via-[#EEF3FF] to-[#FFF8F3] text-slate-900">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

export default MarketingLayout;
